// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './use_case_page.module.less';
import cn from 'classnames';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Input} from '../../../../hola/pub/lib/input';
import {Textarea} from '../../../../hola/pub/lib/textarea';
import {Button} from '../../../../hola/pub/lib/button';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

interface i_use_case {
    text: string;
    link: string;
    desc: string;
    img: string;
    alt_text?: string;
}

interface i_all_cases_props {
    title?: string;
    title_tag?: string;
    subtitle?: string;
    use_case_list: i_use_case[];
}

const Use_case_card = (props: i_use_case)=>{
    const {desc, img, link, text, alt_text = ''} = props;
    const {T} = use_translation_v({no_defaults: true});
    return <Link to={link} className={styles.use_case_card}
      onClick={()=>window.scrollTo(0, 0)}>
      <div className={styles.img}>
        {img.indexOf('/')===0 ? <img src={`https://cdn4.toolip.io${img}`}/> :
          <img src={toolip_img_url(`toolip/${img}.png`)} alt={alt_text}/>}
      </div>
      <div className={styles.text}>
        <p><T>{text}</T></p>
        <span><T>{desc}</T></span>
      </div>
    </Link>;
};

export const All_cases_page = (props: i_all_cases_props)=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    return <div className={cn(theme.container, styles.all_cases_page)}>
      <Dynamic_heading tag={props.title_tag || 'h1'}
        className={cn(styles.title, theme.H2)}>
        <T>{props.title || 'Proxy Use Cases'}</T></Dynamic_heading>
      <p className={cn(theme.u1, styles.subtitle)}>
        <T>{props.subtitle || 'With our premium proxies and experienced team, '
          +'companies can focus on data analysis rather than data delivery. '
          +'Explore toolip proxy solutions for each business case.'}</T>
      </p>
      <div className={styles.use_case_cards}>
        {(props.use_case_list || []).map(u=>
          <Use_case_card key={u.link} {...u}/>)}
      </div>
    </div>;
};

interface i_all_cases_editor_props {
    value: i_all_cases_props;
    on_change: (value: i_all_cases_props)=>void;
    on_cancel: ()=>void;
}

export const All_cases_page_editor = (props: i_all_cases_editor_props)=>{
    const {value, on_change} = props;
    const cases = value.use_case_list || [];
    const update_case = (index: number, field: string, new_val: string)=>{
        const updated = [...cases];
        updated[index] = {...updated[index], [field]: new_val};
        on_change({...value, use_case_list: updated});
    };
    const add_case = ()=>{
        const updated = [...cases, {
            text: '',
            link: '/use-cases/',
            desc: '',
            img: 'cases_',
            alt_text: '',
        }];
        on_change({...value, use_case_list: updated});
    };
    const remove_case = (index: number)=>{
        const updated = cases.filter((_, i)=>i!==index);
        on_change({...value, use_case_list: updated});
    };
    return <div>
      <Input value={value.title || ''} label='Page Title'
        on_change={v=>on_change({...value, title: v})}/>
      <Title_header_select value={value.title_tag} on_select={v=>
        on_change({...value, title_tag: v})}/>
      <Textarea value={value.subtitle || ''} placeholder='Page Subtitle'
        on_change={v=>on_change({...value, subtitle: v})}/>
      <p>Use Cases:</p>
      {cases.map((c, i)=>
        <div key={i} style={{border: '1px solid #ccc', padding: '8px',
          marginBottom: '8px'}}>
          <Input value={c.text} label='Title for the use case'
            on_change={v=>update_case(i, 'text', v)}/>
          <Input value={c.link} label='Link (e.g. /use-cases/web-scraping)'
            on_change={v=>update_case(i, 'link', v)}/>
          <Textarea value={c.desc} placeholder='Description for the use case'
            on_change={v=>update_case(i, 'desc', v)}/>
          <Input value={c.img} label='Image name (e.g. cases_datascrapping)'
            on_change={v=>update_case(i, 'img', v)}/>
          <Input value={c.alt_text || ''} label='Alt text'
            on_change={v=>update_case(i, 'alt_text', v)}/>
          <Button caption='Remove' color='light_red' round={false}
            on_click={()=>remove_case(i)}/>
        </div>
      )}
      <Button caption='Add Use Case' color='blue' round={false}
        on_click={add_case}/>
      <br/>
      <Button caption='Save' on_click={()=>props.on_change(value)}/>
      <Button caption='Cancel' on_click={()=>props.on_cancel()}/>
    </div>;
};
